import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import React, { useEffect, useState } from "react";
import ApiEndpoints from "../network/ApiEndPoints";
import { get } from "../network/ApiController";

const RblBalance = () => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = () => {
    setLoading(true);

    get(
      ApiEndpoints.RBL_BALANCE,
      "",
      null,
      (res) => {
        if (res?.data?.statuscode === "1000") {
          setBalance(res.data.data);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Failed to fetch balance", err);
        setLoading(false);
      },
    );
  };

  return (
    <Box p={3}>
      <Card sx={{ maxWidth: 400 }}>
        <CardContent>
          {/* Header + Refresh Button */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">RBL Wallet Balance</Typography>

            <Button
              size="small"
              startIcon={<RefreshIcon />}
              onClick={fetchBalance}
              disabled={loading}
            ></Button>
          </Stack>

          {loading ? (
            <Typography mt={2}>Loading...</Typography>
          ) : (
            <Typography
              variant="h4"
              mt={2}
              sx={{ fontWeight: "bold", color: "#0F52BA" }}
            >
              ₹ {Number(balance || 0).toLocaleString("en-IN")}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default RblBalance;
